export default class CommonUtil {
    public static removeKeys(jsonObject: any, keys: string[]) {
        let json = JSON.parse(JSON.stringify(jsonObject));
        for (var i = 0; i < keys.length; i++) {
            delete json[keys[i]];
        }
        return json
    }
}

//PASSWORD
export const PASSWORD_REGEX: RegExp = new RegExp(
    /^(?=\S*$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-__+.]).{8,}$/
);